import { postsData } from "../util/postsData.js";
import { ref, reactive, onMounted, watch } from "vue";

export function useArticleBase(postsDataKey) {
    const articles = postsData[postsDataKey];
    const length = articles.length;
    const idx = ref(0);
    const article = reactive({
        title: "",
        slug: "",
        fields: {},
    });

    const updateArticle = (index) => {
        const currentArticle = articles[index];
        article.title = currentArticle.title?.rendered || "";
        article.slug = currentArticle.slug || "";
        article.fields = currentArticle.acf || {};
    };

    onMounted(() => {
        updateArticle(idx.value);
    });

    watch(idx, (newIdx) => {
        updateArticle(newIdx);
    });

    return {
        length,
        idx,
        article,
        articles,
    };
}
